import { Routes, mapToCanActivate, mapToCanDeactivate, mapToResolve } from '@angular/router';

import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';

import { CreateReferenceValueSheetComponent } from './components/create-reference-value-sheet/create-reference-value-sheet.component';
// eslint-disable-next-line max-len
import { CreateRefValSheetFromStandardComponent } from './components/create-reference-value-sheet-from-standard/create-reference-value-sheet-from-standard.component';
import { ReferenceValueSheetOverviewComponent } from './components/reference-value-sheet-overview/reference-value-sheet-overview.component';
import { ReferenceValueSheetRouterComponent } from './components/reference-value-sheet-router/reference-value-sheet-router.component';
import { ReferenceValueSheetGuard } from './guards/reference-value-sheet.guard';
import { GetReferenceValueSheetByIdResolver } from './resolvers/get-reference-value-sheet-by-id.resolver';
import { ReferenceValueSheetOverviewResolver } from './resolvers/reference-value-sheet-overview.resolver';

const referenceValueSheetFeatureRoutes = (isStandard: boolean): Routes => [
  {
    path: '',
    component: ReferenceValueSheetOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    data: { isStandard },
    resolve: {
      data: mapToResolve(ReferenceValueSheetOverviewResolver),
    },
  },
  {
    path: 'create-from-standard',
    component: CreateRefValSheetFromStandardComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'create',
    component: CreateReferenceValueSheetComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    canDeactivate: mapToCanDeactivate([ReferenceValueSheetGuard]),
    data: { isStandard },
    resolve: {
      data: mapToResolve(ReferenceValueSheetOverviewResolver),
    },
  },
  {
    path: 'edit/:id',
    component: CreateReferenceValueSheetComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    data: { isStandard },
    resolve: {
      refValSheet: mapToResolve(GetReferenceValueSheetByIdResolver),
    },
  },
  {
    path: 'view/:id',
    component: CreateReferenceValueSheetComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    data: { isStandard },
    resolve: {
      refValSheet: mapToResolve(GetReferenceValueSheetByIdResolver),
    },
  },
];

export const referenceValueSheetRoutes: Routes = [
  {
    path: 'reference-value-sheet',
    component: ReferenceValueSheetRouterComponent,
    children: referenceValueSheetFeatureRoutes(false),
  },
  {
    path: 'standard-reference-value-sheet',
    component: ReferenceValueSheetRouterComponent,
    children: referenceValueSheetFeatureRoutes(true),
  },
];
